module.exports = {
	appHost: process.env.VUE_APP_API_HOST
}